import { render } from "./RecoveryForm.vue?vue&type=template&id=8c48d280"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__